import { mapActions } from 'vuex';

export default {
  props: {
    links: {
      type: Array,
      required: true,
    },
  },

  computed: {
    activeUrl() {
      const location = window.location;
      return `${location.protocol}//${location.host}${location.pathname}`;
    },
  },

  methods: {
    ...mapActions('currentUser', ['logout']),
  },
};
